import React from 'react';
import styles from './International.module.css';

const International = ({ lang }) => {
  const data = {
    EN: {
      title: "World News",
      news: [
        "Economic shifts in the European markets", "Trade agreements signed in Pacific region", "Tech breakthroughs in Silicon Valley", "Climate summit outcomes in Paris", "Diplomatic talks held in Geneva", "New space exploration project", "Global health update 2026", "Middle East infrastructure project"
      ]
    },
    UR: {
      title: "عالمی خبریں",
      news: [
        "یورپی مارکیٹوں میں معاشی تبدیلیاں", "پیسیفک ریجن میں تجارتی معاہدوں پر دستخط", "سلیکون ویلی میں ٹیکنالوجی کی بڑی پیش رفت", "پیرس میں ماحولیاتی سمٹ کے نتائج", "جنیوا میں سفارتی مذاکرات", "خلا کی تلاش کا نیا منصوبہ", "عالمی ہیلتھ اپ ڈیٹ 2026", "مشرق وسطیٰ کا انفراسٹرکچر منصوبہ"
      ]
    }
  }[lang];

  return (
    <section className={styles.intSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.intGrid}>
        {data.news.map((item, i) => (
          <div key={i} className={styles.intCard}>
            <img src={`https://picsum.photos/300/200?random=${i + 1000}`} alt="world" />
            <div className={styles.content}>
              <span className={styles.date}>July 10, 2026</span>
              <h4>{item}</h4>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default International;